module.exports = __webpack_public_path__ + "static/media/image_39.f8d0369c.png";